'use strict';

require('../copyright/copyright.css');
require('../copyright/copyright.js');
require('./footer.css');
var core_footer_footer = require('./footer.js');



module.exports = core_footer_footer.default;
